import {
  Component,
  DestroyRef,
  TemplateRef,
  ViewChild,
  inject
} from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { NzNotificationService } from 'ng-zorro-antd/notification'
import {
  INotification,
  NotificationService,
  NotificationType
} from '../../../../../shared/services/notification.service'

@Component({
  selector: 'aiomed-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent {
  private readonly destroyRef = inject(DestroyRef)
  private readonly notificationService = inject(NotificationService)
  private readonly nzNotificationService = inject(NzNotificationService)

  @ViewChild('notificationTemplate', { static: false })
  notificationTemplate!: TemplateRef<any>

  private readonly typeClassMap = new Map<NotificationType, string>([
    [NotificationType.Success, 'success'],
    [NotificationType.Warning, 'warning'],
    [NotificationType.Error, 'error']
  ])

  constructor() {
    this.notificationService.notificationsObs$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(notification => {
        if (notification) {
          this.showNotification(notification)
        }
      })
  }

  private showNotification(notification: INotification): void {
    const ref = this.nzNotificationService.template(this.notificationTemplate, {
      nzData: {
        ...notification,
        typeClass: this.typeClassMap.get(notification.type) ?? '',
        close: () => this.nzNotificationService.remove(ref.messageId)
      },
      nzDuration: notification.duration || 3000,
      nzClass: 'aiomed-notification-item',
      nzStyle: { padding: 0, background: 'none', boxShadow: 'none' }
    })
  }
}
